import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from './style.css'

class Home extends Component {
  
  render() {

    return (
      <div className={styles.test}>
      OK
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Home)


// WEBPACK FOOTER //
// ./src/App/pages/Home/index.js